import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=51716174"
import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Profile.vue?vue&type=style&index=0&id=51716174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports